/**
 * Formats a date string or object into a localized format.
 * For French (fr), it uses DD/MM/YYYY HH:mm.
 * For others, it uses a standard medium date/short time format.
 * 
 * @param {Date|string} date - The date to format
 * @param {string} language - The current language code or name (e.g., 'fr', 'en', 'Français')
 * @returns {string} The formatted date string
 */
export const formatDate = (date, language = 'fr') => {
  if (!date) return '—';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '—';

  // Check if language is French (either code 'fr' or the label 'Français')
  const isFrench = language === 'fr' || language === 'fr-FR' || language === 'Français';

  if (isFrench) {
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  // Fallback for other languages
  return d.toLocaleString(language === 'English' ? 'en-US' : 'en-US', {
    dateStyle: 'medium',
    timeStyle: 'short'
  });
};
